import { createApp } from 'vue';

import Request from '@/common/request';
import utils from '@js/modules/utils/utils';
import { showTutorial } from '@js/modules/parts/tutorial';

const app = createApp({
    data: () => {
        return {
            stamp: false,
        };
    },
    methods: {
        // 保存
        mark() {
            utils.loading(true, 0);
            Request.postAs('/save-memory', 'marking_form')
                .then(res => {
                    const response = res.data;
                    const url = response.url;
                    // this.stamp = true;
                    window.location.href = url;
                    // setTimeout(() => {
                    //     window.location.href = url;
                    // }, 500);
                })
                .catch(res => {
                    Request.showErrorResponse(res, 'marking_form');
                    utils.loading(false, 0);
                });
        },
        showTutorial,
    },
    mounted() {
        const tutorial_start = (<HTMLInputElement>document.getElementById('tutorial_start')).value;
        if (tutorial_start == '1') {
            this.showTutorial();
        }
    },
});
app.mount('#memo_part');
